export const NOTIFICATIONS_REFRESH_EVENT = "pitch:refresh-notifications";

export function dispatchNotificationsRefresh() {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_REFRESH_EVENT));
}
